export const SNACKBAR_TRANSITION = 750;
export const ERROR_TIMEOUT = 4000;
export const SUCCESS_TIMEOUT = 4000;
